export const config = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL as string | undefined,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined,
  chromeExtensionUrl: import.meta.env.VITE_CHROME_EXTENSION_URL as string | undefined,
  /** Development-only email + password sign-in (local stacks without Google OAuth). */
  devEmailLogin: import.meta.env.VITE_DEV_EMAIL_LOGIN === '1',
  /** Skip sign-in in dev mode: sign in automatically as the shared local dev user. */
  devAutoLogin: import.meta.env.VITE_DEV_AUTO_LOGIN === '1',
  firefoxExtensionUrl: import.meta.env.VITE_FIREFOX_EXTENSION_URL as string | undefined,
};

export const isConfigured = () => !!config.supabaseUrl && !!config.supabaseAnonKey;
